import { render, staticRenderFns } from "./allMarket.vue?vue&type=template&id=5a637e9a&scoped=true"
import script from "./allMarket.vue?vue&type=script&lang=js"
export * from "./allMarket.vue?vue&type=script&lang=js"
import style0 from "./allMarket.vue?vue&type=style&index=0&id=5a637e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a637e9a",
  null
  
)

export default component.exports